/* eslint-disable react/prop-types */
import classes from "./main-infos.module.scss";

import classNames from "classnames";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
import Grid from "@/components-library/layout/grid";
import TextArea from "@/components-library/widgets/text-area";
function MainInfos({ onTitleChange, isTitleValid, announcement }) {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="center"
      className={classes.infoContainer}
    >
      <Label
        tag="h6"
        weight="bold"
        color="secondary"
        align="start"
        className={classes.subTitle}
      >
        Informazioni principali
      </Label>
      <Grid columns="1fr 1fr 1fr">
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.textArea, {
            [classes.valid]: isTitleValid,
          })}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Titolo*
          </Label>
          <TextArea
            name="Title"
            rows={4}
            onChange={onTitleChange}
            defaultValue={announcement?.title}
          />
        </Flex>
      </Grid>
    </Flex>
  );
}

export default MainInfos;
